


import Vue, { PropType } from 'vue'
import { MapMarker } from '@/interfaces/gmap/Map'

export default Vue.extend({
  props: {
    google: {
      type: Object,
      required: true,
    },
    map: {
      type: Object,
      required: true,
    },
    marker: Object as PropType<MapMarker>,
    infoWindow: Boolean,
  },
  mounted() {
    const marker = new this.google.maps.Marker({
      position: this.marker.position,
      marker: this.marker,
      map: this.map,
      icon: new this.google.maps.MarkerImage(
        this.marker.icon,
        null,
        null,
        new this.google.maps.Point(35, 50),
        new this.google.maps.Size(70, 70)
      ),
    })

    if (this.infoWindow && this.marker.infoWindow) {
      const infoWindow = new this.google.maps.InfoWindow({
        content: `
        <div class="info-window__card">
          <div class="info-window__image" style="background-image: url(${
            this.marker.infoWindow!.image
          });"></div>
          <div class="info-window__info">
            <span>${this.marker.infoWindow!.locality}</span><br>
            <span>${this.marker.infoWindow!.developer}</span>
          </div>
        </div>`,
      })

      marker.addListener('click', () => {
        infoWindow.open(this.map, marker)
      })
    }
  },
})
